export const environment = {
  production: true,
  apiUrl: 'http://34.173.78.244:8088',
  canadaPostAPI: 'http://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3.ws?key=BC54-KB98-AC19-UP12',
  canadaPostRetriveAPI:'http://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Retrieve/v2.11/json3.ws?key=BC54-KB98-AC19-UP12'
};
